import { render, staticRenderFns } from "./CommonLinkSubmenu.vue?vue&type=template&id=46064d19&"
import script from "./CommonLinkSubmenu.vue?vue&type=script&lang=js&"
export * from "./CommonLinkSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports